import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';
SwiperPage3.propTypes = {
  id: PropTypes.string,
  isActive: PropTypes.bool,
};

SwiperPage3.defaultProps = {
  id: '',
  isActive: false,
};

function SwiperPage3({ id, isActive }) {
  const [animationClass, setAnimationClass] = useState('');
  const slides = [{ id: 1 }, { id: 2 }, { id: 3 }];
  useEffect(() => {
    if (isActive) {
      setAnimationClass('active'); // Khi active, chạy animation
    } else {
      setAnimationClass(''); // Nếu không active, reset
    }
  }, [isActive]);

  return (
    <div className={`hero-section hero-section-${id} ${animationClass}`}>
      <div class="hero-content">
        {/* <!-- Information Box --> */}
        <div class="information-sleeve-box">
          <h1 class="title">Bọc Hộp Boardgame</h1>
          <p class="description">
            <span>
              Bảo vệ hộp boardgame khỏi trầy xước, phai màu, hay hư hỏng, giữ cho bộ sưu tập của bạn luôn bền đẹp theo
              thời gian. Lớp bọc chất lượng cao, thẩm mỹ, giúp duy trì giá trị và tăng độ bền cho hộp game yêu thích.
              Chăm sóc boardgame đúng cách, giữ trọn đam mê lâu dài.
            </span>
          </p>
          <div className="cta-button">
            <a
              href="https://www.facebook.com/GamePieceLabs"
              className="cta-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tư vấn bọc hộp
            </a>
          </div>
        </div>
        {/* <!-- Information Box --> */}
        <div className="w-[600px] aspect-[16/9] mx-auto album-sleeve-box">
          <Swiper modules={[Pagination]} pagination={{ clickable: true }} spaceBetween={10} slidesPerView={1}>
            {slides.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className={`w-full h-full bg-cover bg-center sleeve-box-${slide.id}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

export default SwiperPage3;
